// Imports for external libraries go here.
import React, { FC } from 'react';

// Imports for internal (to the monorepo) libraries go here,
// separated by a blank line from external imports.
// The closer the import is to the file the lower it should be in this list.
import { SkeletonLoaderV2Props } from './SkeletonLoaderV2.types';
import { StyledSkeletonLoaderV2 } from './SkeletonLoaderV2.styles';

// Use named rather than default exports.
export const SkeletonLoaderV2: FC<SkeletonLoaderV2Props> = ({ className }) => {
  return (
    <StyledSkeletonLoaderV2
      data-testid="account-SkeletonLoaderV2"
      data-component-name="m-account-SkeletonLoaderV2"
      className={className}
    ></StyledSkeletonLoaderV2>
  );
};
